// https://stackoverflow.com/questions/51292406/check-if-token-expired-using-this-jwt-library
export const isJwtExpired = (jwt) => {
  const expiry = JSON.parse(atob(jwt.split(".")[1])).exp;
  return Math.floor(new Date().getTime() / 1000) >= expiry;
};
